"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSettings = exports.NotificationTypeEnum = exports.ImageType = void 0;
__exportStar(require("./socket"), exports);
__exportStar(require("./feed"), exports);
const zod_1 = require("zod");
var ImageType;
(function (ImageType) {
    ImageType["LIBRARY_ITEM_POSTER"] = "LIBRARY_ITEM_POSTER";
    ImageType["LIBRARY_ITEM_BACKDROP"] = "LIBRARY_ITEM_BACKDROP";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["COMMENT_LIKE"] = "COMMENT_LIKE";
    NotificationTypeEnum["COMMENT_REPLY"] = "COMMENT_REPLY";
    NotificationTypeEnum["LIBRARY_UPDATED"] = "LIBRARY_UPDATED";
    NotificationTypeEnum["LIBRARY_ITEM_UPDATED"] = "LIBRARY_ITEM_UPDATED";
    NotificationTypeEnum["PERSON_SUB_UPDATE"] = "PERSON_SUB_UPDATE";
    NotificationTypeEnum["FEEDBACK_REPLY"] = "FEEDBACK_REPLY";
})(NotificationTypeEnum = exports.NotificationTypeEnum || (exports.NotificationTypeEnum = {}));
const EnabledSchema = zod_1.z
    .object({
    enabled: zod_1.z.boolean().optional(),
    push: zod_1.z.boolean().optional(),
})
    .optional();
exports.NotificationSettings = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    types: zod_1.z.object({
        [NotificationTypeEnum.COMMENT_LIKE]: EnabledSchema,
        [NotificationTypeEnum.COMMENT_REPLY]: EnabledSchema,
        [NotificationTypeEnum.LIBRARY_UPDATED]: EnabledSchema,
        [NotificationTypeEnum.LIBRARY_ITEM_UPDATED]: EnabledSchema,
        [NotificationTypeEnum.PERSON_SUB_UPDATE]: EnabledSchema,
        [NotificationTypeEnum.FEEDBACK_REPLY]: EnabledSchema,
    }),
});
